import React, { useMemo } from 'react';
import {Layout, Menu} from 'antd';
import {environment} from '../../environment';

import styles from './Header.module.scss';
import Icon from '../Icon/Icon';
import { NavLink, useLocation } from 'react-router-dom';
import { useSidebarStore } from '../../store/useSidebar';
import { useMediaQuery } from 'react-responsive';
import useHistoryStack from '../../hooks/useHistoryStack';
import { useUserStore } from '../../store/useUser';
import { navigateToClub } from '../../utils/club';
import useHeader from '../../hooks/useHeader';

const { Header } = Layout;

const CustomHeader= () => {
  const { pathname } = useLocation() as any;
  const { goBack } = useHistoryStack();

  const userId = useUserStore(state => state.id)
  const club = useUserStore(state => state.club)
  const profile = useUserStore(state => state.profile)
  const isMobile = useMediaQuery({ query: '(max-width: 600px)' })

  const { header, subheader } = useHeader(null)

  const menu = useSidebarStore(state => state.menu)

  const activeMenuIndex = useMemo(()=>
    menu?.findIndex(menu => menu.to === pathname) ?? -1
  ,[pathname, menu])

  const activeMenu = useMemo(()=>
    menu?.find(menu => menu.to === pathname)
  ,[pathname, menu])

  const dontShouldShowGobackIcon = 
    (pathname === `/user/${userId}` && profile === 'Clubista')
    || (pathname === navigateToClub(club?.name, club?.id) && (profile === 'Criador' || profile === 'Mediador'))
    || pathname === '/' 
    || pathname === '/login'

  if (isMobile) {
    return (
      <Header className={styles.header}>
        <div className={styles.actions}>
          {!dontShouldShowGobackIcon && 
            <Icon icon='arrow-left' className={styles.trigger} onClick={goBack}/>}
          <div>
            <h1 className={styles.mobileHeaderTitle}>{header || ''}</h1>
            <h2 className={styles.mobileHeaderTitle}>{subheader || ''}</h2>
          </div>
        </div>
      </Header>
    )
  }

  // Não renderiza o menu até ter os dados necessários
  if (!menu || menu.length === 0) {
    return (
      <Header className={styles.header}>
        <div className={styles.extendedMenu}>
          <div className={styles.name}>
            <NavLink to={'/'}>
              <h2 className={styles.appName}>{environment.appName}</h2>
            </NavLink>
          </div>
        </div>
      </Header>
    )
  }

  return (
    <Header className={styles.header}>
      <div className={styles.extendedMenu}>
        <div className={styles.name}>
          <NavLink to={'/'}>
            <h2 className={styles.appName}>{environment.appName}</h2>
          </NavLink>
        </div>
        <Menu
          className={styles.menuItems} 
          mode="horizontal"
          overflowedIndicator={null}
          selectedKeys={[String(activeMenuIndex)]}
          activeKey={String(activeMenu?.key)}
        >
          {menu.map((items) => (
            <React.Fragment key={items.key}>
              {items?.children ? (
                <Menu.SubMenu key={items.key} title={items.label}>
                  {items?.children.map((subItem) => (
                    <Menu.Item key={subItem.key}>
                      <NavLink to={subItem.to} className={styles.link}>
                        {subItem.label}
                      </NavLink>
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              ) : (
                <Menu.Item key={items.key}>
                  <NavLink to={items.to} className={styles.link}>
                    {items.label}
                  </NavLink>
                </Menu.Item>
              )}
            </React.Fragment>
          ))}
        </Menu>
      </div>
    </Header>
  )
}

export default CustomHeader;